import Discover from '@/components/pages/discover/Discover'
import Browse from '@/components/pages/discover/Browse'
import TagDetail from '@/components/pages/discover/TagDetail'

export default [
  { path: '/discover/search/', name: 'discover', component: Discover, meta: { requireLogin: true } },
  { path: '/discover/results/', name: 'discover-results', component: Discover, meta: { action: 'results', requireLogin: true } },
  { path: '/discover/genre/', name: 'discover-genre', component: Browse, meta: { type: 'genre', requireLogin: true } },
  { path: '/discover/genre/:tag', name: 'discover-genre-detail', component: TagDetail, meta: { type: 'genre', requireLogin: true } },
  { path: '/discover/mood/', name: 'discover-mood', component: Browse, meta: { type: 'mood', requireLogin: true } },
  { path: '/discover/mood/:tag', name: 'discover-mood-detail', component: TagDetail, meta: { type: 'mood', requireLogin: true } },
  { path: '/discover/instrument/', name: 'discover-instrument', component: Browse, meta: { type: 'instrument', requireLogin: true } },
  { path: '/discover/instrument/:tag', name: 'discover-instrument-detail', component: TagDetail, meta: { type: 'instrument', requireLogin: true } }
]



// WEBPACK FOOTER //
// ./src/router/discover.js